<template>
  <MainLayout>
    <div class="forgot-password-page">
      <v-card class="forgot-password-card">
        <v-container class="login-form">
          <v-layout fill-weight column class="mx-5">
            <v-layout
              align-center
              column
              class="mt-2"
              style="margin-bottom: 2.5em"
            >
              <!-- <img
                style="width: 100%"
                src="@/assets/images/uplabdh_logo_clear.png"
              /> -->
            </v-layout>

            <v-form
              ref="forgotPasswordForm"
              v-model="formValid"
              lazy-validation
            >
              <!-- Email -->
              <v-text-field
                outline
                prepend-inner-icon="mail_outline"
                v-model="forgotPasswordForm.email"
                hint="Enter your email"
                :rules="rules.email"
                placeholder="Email"
                label="Email"
                single-line
              />

              <!-- Submit -->
              <v-btn
                class="forgot-password-button"
                :loading="loading"
                color="primary"
                dark
                large
                depressed
                @click="submitForm('forgotPasswordForm')"
                style="margin: 0"
              >
                Send Password Reset Link
              </v-btn>
            </v-form>
          </v-layout>
        </v-container>
      </v-card>
    </div>
  </MainLayout>
</template>

<script>
import api from "@/api";

export default {
  metaInfo: {
    title: `Forgot Password`,
    meta: [{ name: "description", content: "Forgot Password" }]
  },

  data() {
    return {
      forgotPasswordForm: {
        email: ""
      },

      rules: {
        email: [
          v => !!v || "E-mail is required",
          v => /.+@.+/.test(v) || "E-mail must be valid"
        ]
      },

      loading: false,
      formValid: false
    };
  },

  computed: {
    appName() {
      return window.config.APP_NAME;
    }
  },

  methods: {
    submitForm(formName) {
      if (this.$refs[formName].validate()) {
        this.requestForgotPassword(this.forgotPasswordForm);
      }
    },

    async requestForgotPassword(req) {
      try {
        this.loading = true;

        const res = await api.forgotPassword(req);

        this.$notify({
          type: "success",
          message: res.data.message
        });
      } catch (error) {
        this.$notify({
          type: "error",
          message: error.message
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="css" scoped>
.forgot-password-page {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.forgot-password-card {
  width: 30em;
  margin-top: 1.875em;
}

@media (max-width: 600px) {
  .forgot-password-card {
    width: 90%;
  }
}

.forgot-password-button {
  width: 100%;
}
</style>
